import { render, staticRenderFns } from "./addMajor.vue?vue&type=template&id=76dcb142&scoped=true&"
import script from "./addMajor.vue?vue&type=script&lang=js&"
export * from "./addMajor.vue?vue&type=script&lang=js&"
import style0 from "./addMajor.vue?vue&type=style&index=0&id=76dcb142&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76dcb142",
  null
  
)

export default component.exports